import * as React from 'react';
import { clsx } from 'clsx';
import styles from './ProgressBar.module.css';
import { UIHeading4, UIText1 } from '../../../typography';
import { BACKGROUND_COLOR, PROGRESS_COLOR } from '../../constants';

/**
 * @param value - текущий прогресс в процентах (от 0 до 100)
 * @param showProgress - отображать ли значение прогресса
 * @param styleType - тип стиля прогресс-бара, может быть 'default' или 'bar'
 * @param title - заголовок прогресс-бара
 * @param bgColor - цвет фона прогресса, если не указан, используется стандарт
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ProgressBar = _ref => {
  let {
    value = 100,
    showProgress = false,
    styleType = 'default',
    valueColor,
    title,
    bgColor
  } = _ref;
  const progress = Math.max(0, value);
  const sizeClass = styleType === 'bar' ? styles.sizeBar : styles.sizeDefault;
  const progressBgColor = bgColor || PROGRESS_COLOR;
  const progressValueColor = valueColor || BACKGROUND_COLOR[styleType];
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [(title || showProgress) && /*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [title && /*#__PURE__*/_jsx(UIHeading4, {
        textAlign: "left",
        children: title
      }), showProgress && /*#__PURE__*/_jsx(UIText1, {
        textAlign: "right",
        children: progress
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: clsx(styles.progressBar, sizeClass),
      style: {
        background: progressBgColor
      },
      role: "progressbar",
      "aria-valuenow": progress,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.progress,
        style: {
          width: "".concat(progress, "%"),
          background: progressValueColor
        }
      })
    })]
  });
};